<template>
    <div class="main">
        <selectTool ref="selectTool"><template slot="btn"></template></selectTool>
        <ul id="fffffff">
            <li v-for="(item, index) in datas" :key="index">
                <Button type="primary">{{ item.name }}</Button>
                <p>总里程：</p>
                <Table border :columns="columns" :data="item.list" no-data-text="<div class='table-no-data'></div>"
                    :height="400">

                </Table>
            </li>
        </ul>
        <Button @click="getList" type="primary">开始测试</Button>
    </div>
</template>
<script>

export default {
    data() {
        return {
            columns: [
                {
                    title: "速度",
                    key: "userName",
                },
                {
                    title: "里程",
                    key: "grade",
                },
                {
                    title: "发动机",
                    key: "groupName",
                },

            ],
            datas: [{
                name: 'diyitian',
                list: []
            }, {
                name: 'diyitian',
                list: []
            }],
            searchForms: [

                {
                    title: "时间范围",
                    key: "startTime",
                    key1: "endTime",
                    type: "lyyymmdd",
                    times: "0",
                },
                {
                    title: "选择车辆",
                    key: "deviceIdList",
                    type: "selectAlotCar",
                },
            ],
            searchItem: {
                deviceNo: "",

            },

        };
    },
    methods: {
        getList() {
        
            this.utils.loading(this, "加载中");
            this.axios({
                method: "post",
                url: this.axios.lbs + "/locus/getOrgLocus",
                data: {
                    deviceNo: '16200136021',
                    endTime: new Date(2024, 6, 7).getTime(),
                    startTime: new Date(2024, 6, 6).getTime(),
                    //pageSize: 100,
                    //pageNumber: 1,
                    returnCoord: 2,
                },
            }).then((res) => {
                this.$Spin.hide(); //关闭加载
                if (res) {
                    this.total = res.data.data.total;
                    var data = res.data.data.dataList.reverse();

                    for (let i = 0; i < data.length; i++) {
                        
                        data[i].gpsTime2 = this.utils.time(data[i].gpsTime);
                 
                    }
                    var data1=[{
                        mileage:1
                    },{
                        mileage:2
                    },{
                        mileage:2
                    },{
                        mileage:3
                    },{
                        mileage:4
                    }]
                 this.cget(data);
                }
            });
        },
        cget(a) {
console.log(a);
            var result = [];
            for (let i = 1; i < a.length - 1; i++) {
                //取一个属，如果他和前面等，比后面小，说明开始行驶，如1，1，2
                if (a[i].mileage -a[i - 1].mileage<0.1 && a[i+1].mileage - a[i].mileage>0.5) {

                    result.push({ index: i, key: 'start' });
                }
                //取一个属，如果他比前面大，和后满相等，说明开始停，如1，2，2.1
                if (a[i].mileage > a[i - 1].mileage>0.5 && a[i+1].mileage -a[i].mileage<0.1) {

                    result.push({ index: i, key: 'stop' });
                }
            }
            console.log(result);

        }
    },
    mounted() {
        this.$refs.selectTool.reach(this.searchForms, this.searchItem);
    },
};
</script>
<style>
#fffffff {
    display: flex;
}
</style>


// WEBPACK FOOTER //
// src/components/report/mi.vue